<template>
  <div>
    <solution-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj="titleObj"
    >
    </solution-header>
    <div v-if="solutionType == 'mother'">
      <!-- 母婴电商 -->
      <solution-mother></solution-mother>
    </div>
    <div v-if="solutionType == 'fresh'">
      <!-- 生鲜电商 -->
      <solution-fresh></solution-fresh>
    </div>
    <div v-if="solutionType == 'medicine'">
      <!-- 生鲜电商 -->
      <solution-medicine></solution-medicine>
    </div>
    <div v-if="solutionType == 'proGramme'">
      <!-- 行业解决方案 -->
      <solution-proramme :img="list.pc_image" :name="list.sub_name"></solution-proramme>
    </div>
    <div v-if="solutionType == 'live'">
      <!-- 直播电商 -->
      <live-commerce></live-commerce>
    </div>
    <div v-if="solutionType == 'brand'">
      <solution-brand></solution-brand>
    </div>
    <div v-if="solutionType == 'o2o'">
      <!-- o2o在线商城 -->
      <online-mall></online-mall>
    </div>
    <div v-if="solutionType == 'whole'">
      <!-- 批发商城 -->
      <wholesale-mall></wholesale-mall>
    </div>
    <div v-if="solutionType == 'supply'">
      <solution-supply></solution-supply>
    </div>
    <!-- b2b2c在线商城 -->
    <div v-if="solutionType == 'onlineShop'">
      <online-shop></online-shop>
    </div>
    <!-- 健身运动 -->
    <div v-if="solutionType == 'fitness'">
      <fitness></fitness>
    </div>
    <!-- 健身运动设计 -->
    <div v-if="solutionType == 'fitPlan'">
      <fit-plan></fit-plan>
    </div>
    <!-- 直播视频 -->
    <div v-if="solutionType == 'classVideo'">
      <class-video></class-video>
    </div>
    <!-- 智慧解决方案 -->
    <div v-if="solutionType == 'wisdom'">
      <wisdom></wisdom>
    </div>
    <!-- 教育解决方案 -->
    <div v-if="solutionType == 'eduction'">
      <education></education>
    </div>
    <!-- 工地解决方案 -->
    <div v-if="solutionType == 'workSite'">
      <work-site></work-site>
    </div>
    <advisory></advisory>
    
    <address class="medicine-footer clearfix">
      <h3>让营销从此变得多姿多彩，现在咨询更多优惠！</h3>
      <a @click="jumpService">立即咨询</a>
    </address>
    <solution-footer
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :bottomNews="bottomNews"
      :productType="productType"
    >
    </solution-footer>
  </div>
</template>

<script>
// pc端
import solutionHeader from '@/components/pc/Header';
import solutionMother from "@/components/pc/solutionMother";
import solutionProramme from '@/components/pc/solutionProramme';
import solutionFresh from "@/components/pc/solutionFresh";
import solutionMedicine from "@/components/pc/solutionMedicine";
import solutionBrand from "@/components/pc/SolutionBrand";
import SolutionSupply from "@/components/pc/SolutionSupply"
import wholesaleMall from "@/components/pc/solutionWholesaleMall";
import onlineMall from "@/components/pc/solutionOnlineMall"
import liveCommerce from "@/components/pc/solutionLiveCommerce";
import Advisory from "@/components/pc/HomeAdvisory"
import solutionFooter from "@/components/pc/Footer";
import onlineShop from "@/components/pc/solutionOnlineShop"
import fitness from "@/components/pc/solutionFitness"
import fitPlan from "@/components/pc/solutionFitPlan"
import classVideo from "@/components/pc/solutionClassVideo"
import wisdom from "@/components/pc/solutionWisdom"
import education from "@/components/pc/solutionEducation"
import workSite from "@/components/pc/solutionWorkSite"
import SolutionProramme from "../../components/pc/solutionProramme.vue"
export default {
  name: "solution",
  data() {
    return {
      solutionType: "",
      topStyle: "",
      actIndex: 3,
      imgList: [],
      logo: '',
      productType: [],
      bottom: {},
      bottomInfo: {},
      bottomNews: [],
      titleObj: {},
      list: {},
    }
  },
  created(){
   
  },
  mounted() {
    let _that = this;
    this.solutionType = this.$route.params.type;
    this.getPageData();
    this.Pc_Mobile();
    const  idd =  window.sessionStorage.getItem('idd');
    this.$http.get(
        "https://eartisanapplets.wsandos.com/api/industry_case/CaseList",
        null,
        (res) => {
          if(idd){
            const result = res.data.case_list;
            const arr = result.filter(item => item.id == idd);
            if(!arr) return;
            this.list = arr[0];
          }
        }
      );
 

  
    switch (this.solutionType) {
      case "proGramme":
      const  name =  window.sessionStorage.getItem('name');
      const  sub_name =  window.sessionStorage.getItem('sub_name');
        this.titleObj = {
          title: name,
          desc: sub_name,
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/programme/banner.png") +
          "')";
        break;
      case "mother":
        this.titleObj = {
          title: "母婴电商解决方案",
          desc:
            "母婴零售商实现实体转型，打通母婴市场线上和线下的全渠道服务，\n拉近和用户的距离",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/mother/bg.png") +
          "')";
        break;
      case "fresh":
        this.titleObj = {
          title: "生鲜电商解决方案",
          desc:
            "根据行业痛点，专注于为生鲜企业提供完善、个性化、\n定制化的解决方案 ",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/fresh/bg.png") +
          "')";
        break;
      case "medicine":
        this.titleObj = {
          title: "医药电商解决方案",
          desc:
            "为消费者提供医药一站式的网上电商平台，支持多个渠道购买，\n同时提供健康服务的在线支持",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/medicine/bg.png") +
          "')";
        break;
      case "live":
        this.titleObj = {
          title: "直播电商解决方案",
          desc: "将线下实体店转到线上，延续互联网优势\n解决实体店地域限制等难题",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/solution/live_banner11.png") +
          "')";
        break;
      case "o2o":
        this.titleObj = {
          title: "O2O在线商城解决方案",
          desc: "构建品牌商、零售商自己的多终端\n全渠道线上零售商城助力企业快速进入电商新时代",
        };
        this.topStyle =
          "background-image:url('" +
          require("../../static/images/solution/onlineShopBanner1.png") +
          "')";
        break;
      case "whole":
        this.titleObj = {
          title: "B2B批发商城系统一站式解决方案",
          desc: "企业之间通过互联网\n为客户提供更好的服务",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/onlineShopBanner1.png") +
          "')";
        break;
        case "brand":
        this.titleObj = {
          title: "B2C自营品牌商城解决方案",
          desc: "构建品牌商、零售商自己的多终端\n全渠道线上零售商城助力企业快速进入电商新时代",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/whole_banner1.png") +
          "')";
        break;
         case "supply":
        this.titleObj = {
          title: "S2B2B2C电商供应链系统",
          desc: "构建完美企业级供应链电商体系解决实业\n+互联网困局为传统实业量身定做",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/onlineShopBanner1.png") +
          "')";
        break;
        case "onlineShop":
        this.titleObj = {
          title: "B2B2C在线商城解决方案",
          desc: "以丰富的营销功能，精细化的用户运营\n解决多商城电商系统引流、推广难题\n帮助企业打造生态级B2B2C多商城系统盈利模式",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/onlineShopBanner1.png") +
          "')";
        break;
        case "fitness":
        this.titleObj = {
          title: "健身场馆管理解决方案",
          desc: "一套系统，打通健身房管理所有环节\n降低管理成本，提高运营效率，提升品牌形象",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/fitness17.png") +
          "')";
        break;
        case "fitPlan":
        this.titleObj = {
          title: "运动健身平台解决方案",
          desc: "运动健身平台开发迎合运动人士的需求\n定位于专业的健身产品，对于健身市场固有的传统模式实现变革\n打破行业信息传播渠道局限的问题",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/fitPlanBan11.png") +
          "')";
        break;
        case "classVideo":
        this.titleObj = {
          title: "直播课程解决方案",
          desc: "以直播实时互动、点播资源沉淀为特色，为K12体制内管理者、教师、学生提供全方位的教学、管理和运营服务，使课内教学与课外学习融为一体。\n 通过大数据分析进行诊断，为学生制定个性化的课程和学习路径，实现因材施教。重在培养学生自主学习的能力，最终实现个性化学习",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/fitPlanBan.png") +
          "')";
        break;
        case "wisdom":
        this.titleObj = {
          title: "智慧景区解决方案",
          desc: "为景区建设一套线上、线下相结合的信息化综合服务系统，全面提升景区信息化水平，优化景区业务流程\n 提高运营管理效率，提升游客旅游体验；同时，利用大数据分析为景区的运行监控、旅游安全、应急智慧等方面提供数据依据",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/fitPlanBan1.png") +
          "')";
        break;
        case "eduction":
        this.titleObj = {
          title: "新教育解决方案",
          desc: "当内容+复购+线下成为了新的需求，\n当课程化、系统化、线下化成为必然趋势，教育和知识付费之间的边界也被打破了",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/fitPlanBan.png") +
          "')";
        break;
        case "workSite":
        this.titleObj = {
          title: "智慧工地解决方案",
          desc: "围绕施工现场管理，运用先进的技术，构建全方位的智能监控防范体系弥补传统方法和技术在监管中的缺陷\n形成安全、质量、进度、人员、机械、绿色施工六大针对性解决方案。 ",
        };
        this.topStyle = "background-image:url('" +
          require("../../static/images/solution/fitPlanBan.png") +
          "')";
        break;
    }
  },
  methods: {
    jumpService() {
      this.$addConsult()
    },
    getPageData() {
      this.$http.post('home/index/product', null, (res) => {
      //   console.log(res.data)
        this.bottom = res.data.bottom[0]
        this.logo = this.bottom.logo
        this.bottomInfo = res.data.contact[0]
        this.productType = res.data.type
        this.productAll = res.data.product
        this.bottomNews = res.data.b_news
      })
    },
      _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_solution/1");
      } else {
        this.$router.push("/solution/"+this.solutionType);
      }
    },
  },
  components: {
    solutionMother,
    solutionFresh,
    solutionMedicine,
    solutionProramme,
    wholesaleMall,
    onlineMall,
    liveCommerce,
    solutionHeader,
    solutionBrand,
    solutionFooter,
    SolutionSupply,
    Advisory,
    onlineShop,
    fitness,
    fitPlan,
    classVideo,
    wisdom,
    education,
    workSite,
    SolutionProramme
}
}
</script>

<style  lang="stylus" scoped>

.medicine-footer {
  width: 100%;
  height: 160px;
  margin-top: 145px;
  background: url('../../static/images/fiveG/bg(1).png');
  text-align: center;
  border-sizing: border-box;
  position: relative;
  z-index: 8;

  h3 {
    padding-top: 28px;
    font-size: 24px;
    line-height: 28px;
    color: #FFFFFF;
  }

  a {
    text-decoration: none;
    display: inline-block;
    width: 170px;
    height: 50px;
    margin: 24px auto;
    font-size: 18px;
    font-weight: bold;
    color: #FFFEFC;
    line-height: 50px;
    border: 1px solid #FFFEFC;
    border-radius: 4px;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/solution.vue